module.exports = __webpack_public_path__ + "img/checksurat-min.7999272c.png";